import React from "react";

const SvgMarkerBell = ({ svgRef, title, ...props }) => (
  <svg width="1em" height="1em" viewBox="0 0 30 47" ref={svgRef} {...props}>
    <title>{title}</title>
    <defs>
      <path
        id="MarkerBell_svg__a"
        d="M730 513c-3.314 0-6 1.119-6 2.5s2.686 2.5 6 2.5 6-1.119 6-2.5-2.686-2.5-6-2.5z"
      />
      <path
        id="MarkerBell_svg__b"
        d="M730 471c-8.293 0-15 6.886-15 15.4 0 11.55 15 28.6 15 28.6s15-17.05 15-28.6c0-8.514-6.707-15.4-15-15.4"
      />
      <path
        id="MarkerBell_svg__c"
        d="M734.77 489.935v-3.397c0-2.361-1.262-4.338-3.462-4.861v-.523c0-.639-.516-1.154-1.154-1.154-.639 0-1.154.515-1.154 1.154v.523c-2.208.523-3.462 2.492-3.462 4.862v3.396L724 491.473v.77h12.308v-.77zm-3.088 3.527h-3.067c0 .846.683 1.538 1.534 1.538a1.54 1.54 0 0 0 1.533-1.538z"
      />
    </defs>
    <use
      fill="#6f7070"
      xlinkHref="#MarkerBell_svg__a"
      opacity={0.4}
      transform="translate(-715 -471)"
    />
    <use
      fill="#ff5d58"
      xlinkHref="#MarkerBell_svg__b"
      transform="translate(-715 -471)"
    />
    <use
      fill="#fff"
      xlinkHref="#MarkerBell_svg__c"
      transform="translate(-715 -471)"
    />
  </svg>
);

const ForwardRef = React.forwardRef((props, ref) => (
  <SvgMarkerBell svgRef={ref} {...props} />
));
export default ForwardRef;



// WEBPACK FOOTER //
// ./src/common/icons/MarkerBell.js